export default {"src":"/uk/_next/static/media/portfolio-money.38a89250.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};